export function TasteBar({
  label,
  value,
  fill,
  height = 3,
  animated = false,
  showValue = false,
}: {
  label: string;
  value: number;
  fill?: number;
  height?: 3 | 4;
  animated?: boolean;
  showValue?: boolean;
}) {
  const width = (fill ?? value) * 10;
  return (
    <div>
      {showValue && (
        <div className="mb-1 flex justify-between">
          <span className="mono-label">{label}</span>
          <span className="font-mono text-[11px] text-ink">{value}/10</span>
        </div>
      )}
      {/* biome-ignore lint/a11y/useSemanticElements: custom-styled meter needs a div for the accent-colored fill; native <meter> can't be styled to match */}
      <div
        className="w-full bg-line"
        style={{ height }}
        role="meter"
        aria-label={label}
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={10}
      >
        <div
          className="h-full bg-accent"
          style={{
            width: `${width}%`,
            transition: animated ? 'width 900ms cubic-bezier(.2,.8,.2,1)' : undefined,
          }}
        />
      </div>
    </div>
  );
}
